import React, { useState } from 'react';
import { createRoot } from 'react-dom/client';
import CustomSwal from './CustomSwal';

const sendSwal = (isDonationMode = false, options = {}) => {
  const { title, text, placeholder, confirmButtonText, cancelButtonText, requireInput } = options;
  return new Promise((resolve) => {
    const tempDiv = document.createElement('div');
    tempDiv.id = 'custom-swal-container';
    document.body.appendChild(tempDiv);
    const root = createRoot(tempDiv);

    const cleanup = () => {
      if (tempDiv.parentNode) tempDiv.parentNode.removeChild(tempDiv);
      root.unmount();
    };

    const SwalWrapper = () => {
      const [isOpen, setIsOpen] = useState(true);

      const handleConfirm = (reason) => {
        setIsOpen(false);
        resolve(reason);
        setTimeout(cleanup, 350);
      };

      const handleClose = () => {
        setIsOpen(false);
        resolve(null);
        setTimeout(cleanup, 350);
      };

      return (
        <CustomSwal
          isOpen={isOpen}
          onClose={handleClose}
          onConfirm={handleConfirm}
          isDonationMode={isDonationMode}
          title={title}
          text={text}
          placeholder={placeholder}
          confirmButtonText={confirmButtonText}
          cancelButtonText={cancelButtonText}
          requireInput={requireInput}
        />
      );
    };

    root.render(<SwalWrapper />);
  });
};

export default sendSwal;
